import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import store from './store'
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { historyObject } from './constants/index'
import './index.scss'

const render = () => ReactDOM.render(
  <Router history={historyObject}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById( 'root' ) )

render()
registerServiceWorker()

// console.log( console.log( 'Só pra saber se ta compilando essa #ˆ%!%ˆ%@%$#!' ) )



if ( module.hot && process.env.NODE_ENV === 'development' ) {
  module.hot.accept()
  render()
}


// WEBPACK FOOTER //
// ./src/index.js